var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import CountrySelect from '@/shared/components/input/CountrySelect';
import DataCacheService from '@/shared/services/DataCacheService';
import { isDutchTenantConfiguration } from '@/shared/TenantConfigurationConstants';
import messages from '../companyMessages';
var AddCompanyModal = function (_a) {
    var _b, _c, _d;
    var show = _a.show, onClose = _a.onClose, onSave = _a.onSave, isCreating = _a.isCreating;
    var intl = useIntl();
    var tenantConfiguration = (_b = DataCacheService.getDataCache()) === null || _b === void 0 ? void 0 : _b.tenantConfiguration;
    var isNetherlands = isDutchTenantConfiguration(tenantConfiguration);
    var defaultCountry = ((_d = (_c = DataCacheService.getDataCache()) === null || _c === void 0 ? void 0 : _c.defaultcompany) === null || _d === void 0 ? void 0 : _d.countryCode) || 'BE';
    var _e = useState(''), name = _e[0], setName = _e[1];
    var _f = useState(''), enterpriseNumber = _f[0], setEnterpriseNumber = _f[1];
    var _g = useState(''), kvkNumber = _g[0], setKvkNumber = _g[1];
    var _h = useState(defaultCountry), countryCode = _h[0], setCountryCode = _h[1];
    var _j = useState(false), showValidation = _j[0], setShowValidation = _j[1];
    var resetState = function () {
        setName('');
        setEnterpriseNumber('');
        setKvkNumber('');
        setCountryCode(defaultCountry);
        setShowValidation(false);
    };
    React.useEffect(function () {
        if (show)
            resetState();
    }, [show]);
    var isValid = function () {
        if (!name)
            return false;
        if (!isNetherlands && !enterpriseNumber)
            return false;
        if (isNetherlands && !kvkNumber)
            return false;
        return true;
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setShowValidation(true);
            if (!isValid())
                return [2 /*return*/];
            return [2 /*return*/, onSave({
                    name: name,
                    enterpriseNumber: isNetherlands ? undefined : enterpriseNumber,
                    kvkNumber: isNetherlands ? kvkNumber : undefined,
                    countryCode: countryCode,
                })];
        });
    }); };
    return (_jsx(OkCancelModal, __assign({ title: intl.formatMessage(messages.AddCompany), show: show, onClose: onClose, onSave: handleSave, okLabel: intl.formatMessage(messages.Add), disabled: isCreating || (showValidation && !isValid()), disableFullScreen: true }, { children: _jsxs("div", __assign({ className: "form-horizontal", role: "form" }, { children: [_jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ htmlFor: "companyName", className: "col-sm-4 control-label" }, { children: intl.formatMessage(messages.Name) })), _jsx("div", __assign({ className: "col-sm-8" }, { children: _jsx("input", { type: "text", id: "companyName", className: "form-control".concat(showValidation && !name ? ' markedError' : ''), value: name, onChange: function (e) { return setName(e.target.value); }, placeholder: intl.formatMessage(messages.Name), autoFocus: true }) }))] })), !isNetherlands && (_jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ htmlFor: "enterpriseNumber", className: "col-sm-4 control-label" }, { children: intl.formatMessage(messages.EnterpriseNumber) })), _jsx("div", __assign({ className: "col-sm-8" }, { children: _jsx("input", { type: "text", id: "enterpriseNumber", className: "form-control".concat(showValidation && !enterpriseNumber ? ' markedError' : ''), value: enterpriseNumber, onChange: function (e) { return setEnterpriseNumber(e.target.value); }, placeholder: intl.formatMessage(messages.EnterpriseNumber), maxLength: 256 }) }))] }))), isNetherlands && (_jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ htmlFor: "kvkNumber", className: "col-sm-4 control-label" }, { children: intl.formatMessage(messages.KVKNumber) })), _jsx("div", __assign({ className: "col-sm-8" }, { children: _jsx("input", { type: "text", id: "kvkNumber", className: "form-control".concat(showValidation && !kvkNumber ? ' markedError' : ''), value: kvkNumber, onChange: function (e) { return setKvkNumber(e.target.value); }, placeholder: intl.formatMessage(messages.KVKNumber), maxLength: 256 }) }))] }))), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ htmlFor: "inputCountry", className: "col-sm-4 control-label" }, { children: intl.formatMessage(messages.Country) })), _jsx("div", __assign({ className: "col-sm-8" }, { children: _jsx(CountrySelect, { value: countryCode, onChange: function (code) { return setCountryCode(code || 'BE'); } }) }))] }))] })) })));
};
export default AddCompanyModal;
